"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "mx-auto mt-10 w-100 max-w-full px-4 lg:w-full" };
const _hoisted_2 = { class: "ocm-headline2 mb-4 w-[200px]" };
const store_1 = require("@/state/store");
const BenefitItems_vue_1 = __importDefault(require("@/components/BenefitItems.vue"));
const main_1 = require("@/main");
exports.default = (0, vue_1.defineComponent)({
    __name: 'BenefitsLandingPage',
    props: {
        items: {}
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("h2", _hoisted_2, (0, vue_2.toDisplayString)((0, vue_2.unref)(main_1.$t)("benefits_headline")), 1),
                (_ctx.items.length)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(BenefitItems_vue_1.default, {
                        key: 0,
                        items: _ctx.items,
                        "is-landing-page": (0, vue_2.unref)(store_1.store).isLandingPage
                    }, null, 8, ["items", "is-landing-page"]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
